function normalizeYearFragment(fragment, pivotYear = null) {
  const digits = (fragment || '').replace(/[^0-9]/g, '');
  if (!digits) return null;
  if (digits.length === 4) return Number(digits);
  if (digits.length <= 2) {
    const value = Number(digits);
    if (Number.isNaN(value)) return null;
    if (pivotYear != null && Number.isFinite(pivotYear)) {
      const pivotCentury = Math.floor(pivotYear / 100) * 100;
      let candidate = pivotCentury + value;
      if (candidate < pivotYear) candidate += 100;
      return candidate;
    }
    const defaultCentury = value >= 30 ? 1900 : 2000;
    return defaultCentury + value;
  }
  return null;
}

function parseYearToken(rawToken) {
  const cleaned = (rawToken || '').replace(/\s+/g, '');
  if (!cleaned) return null;
  const rangeMatch = cleaned.match(/^(\d{0,4})-(\d{0,4})$/);
  if (rangeMatch) {
    const left = rangeMatch[1];
    const right = rangeMatch[2];
    if (!left && !right) return null;

    const start = left ? normalizeYearFragment(left) : null;
    if (left && start == null) return null;

    const end = right ? normalizeYearFragment(right, start) : null;
    if (right && end == null) return null;

    if (start != null && end != null && end < start) return null;

    return { kind: 'range', start, end, raw: rawToken };
  }
  if (/^\d{1,4}$/.test(cleaned)) {
    const year = normalizeYearFragment(cleaned);
    if (year != null) {
      return { kind: 'single', year, raw: rawToken };
    }
  }
  return { kind: 'text', value: cleaned.toLowerCase(), raw: rawToken };
}

function tokenizeYearFilter(value) {
  if (!value) return [];
  const primaryParts = value
    .split(/[;,]/)
    .map(part => part.trim())
    .filter(Boolean);
  const tokens = [];
  primaryParts.forEach(part => {
    part.split(/\s+/).forEach(bit => {
      const trimmed = bit.trim();
      if (trimmed) tokens.push(trimmed);
    });
  });
  return tokens;
}

function matchYearToken(token, yearValues, yearsLower) {
  if (!token) return true;
  const safeYears = Array.isArray(yearValues) ? yearValues : [];
  const fallbackNeedle = String(token.raw || '').toLowerCase();
  if (token.kind === 'range') {
    if (!safeYears.length) return yearsLower.includes(fallbackNeedle);
    return safeYears.some(year => {
      if (token.start != null && year < token.start) return false;
      if (token.end != null && year > token.end) return false;
      return true;
    });
  }
  if (token.kind === 'single') {
    if (!safeYears.length) {
      if (fallbackNeedle) return yearsLower.includes(fallbackNeedle);
      return false;
    }
    return safeYears.includes(token.year);
  }
  return yearsLower.includes(token.value);
}

export function matchesYearFilter(yearValues = [], yearsDisplay = '', filterValue = '') {
  const query = (filterValue || '').trim();
  if (!query) return true;
  const tokens = tokenizeYearFilter(query)
    .map(parseYearToken)
    .filter(Boolean);
  const yearsLower = String(yearsDisplay || '').toLowerCase();
  if (!tokens.length) {
    return yearsLower.includes(query.toLowerCase());
  }
  return tokens.every(token => matchYearToken(token, yearValues, yearsLower));
}

export function attachYearValues(years = []) {
  if (!Array.isArray(years) || !years.length) return [];
  const deduped = Array.from(new Set(years.filter(year => Number.isFinite(year))));
  return deduped.sort((a, b) => a - b);
}
